import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle, Headphones, Youtube } from 'lucide-react';
export function FeaturedPodcast() {
  return <section className="max-w-[96rem] mx-auto px-4 sm:px-6 lg:px-8 py-16 border-thick-b" data-id="element-27">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="bg-accent-dark text-cream flex flex-col md:flex-row overflow-hidden border-4 border-accent-dark" data-id="element-28">
        {/* Artwork */}
        <div className="md:w-2/5 lg:w-1/3 aspect-square md:aspect-auto relative bg-ink shrink-0 border-b-4 md:border-b-0 md:border-r-4 border-cream" data-id="element-29">
          <img src="https://images.unsplash.com/photo-1522778526097-ce0a22ceb253?q=80&w=1000&auto=format&fit=crop" alt="An empty football stadium from the sideline" className="w-full h-full object-cover opacity-60 mix-blend-luminosity" data-id="element-30" />
          <div className="absolute inset-0 bg-accent-dark/40" data-id="element-31"></div>
          <div className="absolute bottom-6 left-6 right-6" data-id="element-32">
            <h3 className="font-serif text-4xl sm:text-5xl font-black tracking-tighter uppercase leading-none" data-id="element-33">
              The Skybox
              <br data-id="element-34" />
              Podcast
            </h3>
          </div>
        </div>

        {/* Content */}
        <div className="p-8 md:p-12 lg:p-16 flex flex-col justify-center flex-grow" data-id="element-35">
          <div className="mb-8" data-id="element-36">
            <span className="kicker-block-inverse text-sm" data-id="element-37">Latest Episode</span>
          </div>

          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.9] font-black mb-6 tracking-tighter" data-id="element-38">
            <span className="text-cream/50 mr-4 font-mono text-4xl lg:text-5xl align-top" data-id="element-39">
              #142
            </span>
            How DraftKings Quietly Won the Sportsbook Wars
          </h2>

          <p className="font-sans text-xl sm:text-2xl font-medium text-cream/80 mb-10 max-w-3xl leading-snug" data-id="element-40">
            A former senior executive joins us to break down the unit economics
            of legal sportsbooks, why customer acquisition cost is the only
            number that matters, and what the next wave of state-by-state
            expansion really looks like.
          </p>

          <div className="flex flex-wrap items-center gap-6 mt-auto" data-id="element-41">
            <button className="flex items-center space-x-3 bg-cream hover:bg-ink hover:text-cream text-accent px-8 py-4 font-sans font-black uppercase tracking-widest transition-colors border-2 border-cream hover:border-ink" data-id="element-42">
              <PlayCircle className="w-6 h-6" data-id="element-43" />
              <span data-id="element-44">Play Episode</span>
            </button>

            <div className="flex items-center space-x-6 ml-2" data-id="element-45">
              <button className="p-2 text-cream/60 hover:text-cream transition-colors" aria-label="Listen on Apple Podcasts" data-id="element-46">
                <Headphones className="w-8 h-8" data-id="element-47" />
              </button>
              <button className="p-2 text-cream/60 hover:text-cream transition-colors" aria-label="Listen on Spotify" data-id="element-48">
                <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor" data-id="element-49">
                  <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.24 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15.001 10.62 18.66 12.9c.42.24.54.84.3 1.14zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" data-id="element-50" />
                </svg>
              </button>
              <button className="p-2 text-cream/60 hover:text-cream transition-colors" aria-label="Watch on YouTube" data-id="element-51">
                <Youtube className="w-8 h-8" data-id="element-52" />
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}